var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "channel-info-form" },
    [
      _c(
        "el-form",
        {
          ref: "channelFormRef",
          attrs: {
            model: _vm.channelForm,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "渠道身份" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择渠道身份" },
                      model: {
                        value: _vm.channelForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.channelForm, "type", $$v)
                        },
                        expression: "channelForm.type",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "渠道名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入渠道名称", maxlength: 30 },
                    model: {
                      value: _vm.channelForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelForm, "name", $$v)
                      },
                      expression: "channelForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入地址", maxlength: 100 },
                    model: {
                      value: _vm.channelForm.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelForm, "address", $$v)
                      },
                      expression: "channelForm.address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "负责人", prop: "admin" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入负责人" },
                    model: {
                      value: _vm.channelForm.admin,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelForm, "admin", $$v)
                      },
                      expression: "channelForm.admin",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入邮箱", maxlength: 30 },
                    model: {
                      value: _vm.channelForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelForm, "email", $$v)
                      },
                      expression: "channelForm.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-row phone" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.channelForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelForm, "phone", $$v)
                      },
                      expression: "channelForm.phone",
                    },
                  }),
                  _c(
                    "span",
                    { staticClass: "tip", staticStyle: { color: "red" } },
                    [_vm._v("渠道商登录使用，请谨慎填写")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.channelForm.type === 1
            ? _c(
                "div",
                { staticClass: "form-row phone" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "新用户注册下单时效",
                        prop: "validityHours",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "number", placeholder: "请输入数字" },
                        model: {
                          value: _vm.channelForm.validityHours,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelForm, "validityHours", $$v)
                          },
                          expression: "channelForm.validityHours",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "tip", staticStyle: { width: "330px" } },
                        [
                          _vm._v("\n          小时\n          "),
                          _c(
                            "label",
                            {
                              staticStyle: {
                                color: "red",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n            用户扫描渠道码注册成功后的订单返佣时效\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "渠道码有效期", prop: "dateRange" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.channelForm.dateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelForm, "dateRange", $$v)
                      },
                      expression: "channelForm.dateRange",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "请输入备注" },
                model: {
                  value: _vm.channelForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.channelForm, "remark", $$v)
                  },
                  expression: "channelForm.remark",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "form-title" }, [_vm._v("渠道比例")]),
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "首笔订单", prop: "fristOrder" } },
                [
                  _c(
                    "div",
                    { staticClass: "ratio-input" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "120px" },
                        attrs: { type: "number", placeholder: "请输入数字" },
                        model: {
                          value: _vm.channelForm.fristOrder,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelForm, "fristOrder", $$v)
                          },
                          expression: "channelForm.fristOrder",
                        },
                      }),
                      _c("span", [_vm._v("%")]),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "复购订单", prop: "commondOrder" } },
                [
                  _c(
                    "div",
                    { staticClass: "ratio-input" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "120px" },
                        attrs: { type: "number", placeholder: "请输入数字" },
                        model: {
                          value: _vm.channelForm.commondOrder,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelForm, "commondOrder", $$v)
                          },
                          expression: "channelForm.commondOrder",
                        },
                      }),
                      _c("span", [_vm._v("%")]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }